import { getInputSound } from 'CHECKS/microphone/volumeMeter';
import { onUnhandledError } from 'UTILS/callbacks';

const start = async({
  onError = () => {},
  onSuccess = () => {},
  onEnd = () => {},
  deviceId,
  logger,
}) => {
  try {
    await getInputSound(({
      deviceId,
      logger,
    }));
    onSuccess('microphone_detected');
  } catch (err) {
    switch (err.name) {
      case 'OverconstrainedError':
      case 'NotFoundError':
        onError('microphone_not_detected');
        break;
      case 'AbortError':
      case 'NotReadableError':
        onError('microphone_not_available');
        break;
      case 'NotAllowedError':
        // TODO: What should we do here? (ie. the user removed the permissions after accepting them first)
        break;
      case 'Error':
        if (err.message === 'no_volume_timeout') {
          onError('sound_not_detected');
        } else {
          onUnhandledError(err);
          onError('volume_check_impossible');
        }
        break;
      default:
        onUnhandledError(err);
        onError('volume_check_impossible');
    }
  } finally {
    onEnd();
  }
};

export default {
  start,
};
